import React, {useContext} from "react";
import i18n from "../../../../../i18n/i18n";
import Table from "../../../../../common/components/shared/table/table";
import {DamageModelWithDirection} from "../../../../models/tcr";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../../../helpers/routing";
import {RouteComponentProps, withRouter} from "react-router";
import TcrUtils from "../../../../../helpers/tcrUtils";
import TransportUtils from "../../../../../helpers/transportUtils";
import {storesContext} from "../../../../../common/stores/stores";

interface TrailerConditionProps extends RouteComponentProps {
    isUpdate: boolean;
}

function TrailerCondition(props: TrailerConditionProps): React.ReactElement {
    const tcrStore = useContext(storesContext).tcrStore;
    const damages = tcrStore.damages || null;
    const orderId = tcrStore.orderId || "";
    const properties = ["sideType", "damageUpdateTime", "equipmentType", "damageType", "direction"];
    const headers = properties.map(key => i18n.t("transportation.order.tcr.sections.trailerCondition.damageHeaders." + key));

    return (
        <div className="section">
            <div className="sub-header" data-testid="trailer-condition-header">
                {i18n.t("transportation.order.tcr.sections.trailerCondition.header")}
            </div>
            <Table
                headers={headers}
                rows={TransportUtils.renderDamageOrPhotoRows("tcr", damages)}
                properties={properties}
                testId="damages"
                renderCell={renderCell}
                pageable={false}
                currentPage={0}
                numberOfElements={0}
                actions={props.isUpdate && tcrStore.direction ? renderActions : undefined}
                renderEmptyCell={true}
            />
        </div>
    );

    function renderCell(row: any, property: string): JSX.Element {
        const value = row[property];
        switch (property) {
            case "sideType":
                return TransportUtils.renderSideType("transportation.order.tcr.sections.trailerCondition", value);
            case "damageUpdateTime":
                return TcrUtils.renderDamageUpdateTime(value);
            case "equipmentType":
                return TcrUtils.renderEquipment(row);
            case "damageType":
                return TcrUtils.renderDamageType(value);
            case "direction":
                return TransportUtils.renderDirection(value);
            default:
                return value;
        }
    }

    function renderActions(damage: DamageModelWithDirection): JSX.Element {
        const sideType = damage.sideType;

        return (
            <NavLink
                to={`${routingAddresses.order.modifyTrailerDamages}/${orderId}/${sideType}`}
                className="action-button"
                data-testid="manage"
            >
                {i18n.t("transportation.order.tcr.sections.trailerCondition.actions.manage")}
            </NavLink>
        );
    }
}

export default withRouter(TrailerCondition);